<template>
  <div class="software-info-footer">
    <span
      ><a href="https://www.zelfpos.com" class="text-link"
        >Powered by ZelfPOS</a
      >
      | POS ID:
      {{ posUuid }}
    </span>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useSystemSettingsStore } from "@/stores/systemSettings";

const { getPosClientId } = useSystemSettingsStore();
const posUuid = computed(() => getPosClientId());
</script>

<style scoped>
.software-info-footer {
  font-size: 13.5px;
  text-align: center;
}
</style>
